import { storage, storageKeys } from "./storage";
import { CUSTOMER_AUTH_CHANGED_EVENT } from "./app-notify";

export interface AuthUserInfo {
  id?: number;
  nickname?: string;
  avatar?: string;
  mobile?: string;
}

const notifyAuthChanged = () => {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new Event(CUSTOMER_AUTH_CHANGED_EVENT));
};

export const auth = {
  getToken() {
    return storage.get<string>(storageKeys.token) || "";
  },

  setToken(token: string) {
    storage.set(storageKeys.token, token);
    notifyAuthChanged();
  },

  clearToken() {
    storage.remove(storageKeys.token);
    notifyAuthChanged();
  },

  getUserInfo() {
    return storage.get<AuthUserInfo>(storageKeys.userInfo);
  },

  setUserInfo(userInfo: AuthUserInfo) {
    storage.set(storageKeys.userInfo, userInfo);
    notifyAuthChanged();
  },

  clearUserInfo() {
    storage.remove(storageKeys.userInfo);
    notifyAuthChanged();
  },

  clearSession() {
    this.clearToken();
    this.clearUserInfo();
  },
};
